/**
 * @description
 *
 * Возвращает CSS-свойство DOM-элемента
 *
 * @param { HTMLElement } node - узел, свойство которого необходимо вернуть
 * @param {string} prop - название свойства
 *
 * @returns {string} - значение указанного свойства
 */

function getCSSProp(node, prop) {
  if (node && prop) {
    return getComputedStyle(node)[prop]
  }
}

export default getCSSProp
